import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

const Home = lazy(() => import("./pages/Home"));
const Resources = lazy(() => import("./pages/Resources"));
const SuccessStories = lazy(() => import("./pages/SuccessStories"));
const Solutions = lazy(() => import("./pages/Solutions"));
const Industries = lazy(() => import("./pages/Industries"));
const Contact = lazy(() => import("./pages/Contact"));
const Manufacturing = lazy(() => import("./pages/Manufacturing"));
const KraEtims = lazy(() => import("./pages/KraEtims"));
const HrPayroll = lazy(() => import("./pages/HrPayroll"));
const Pricing = lazy(() => import("./pages/Pricing"));
const BlogPost = lazy(() => import("./components/BlogPost"));
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" role="status" aria-label="Loading"></div></div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<BlogPost />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/hr-payroll" element={<HrPayroll />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/manufacturing" element={<Manufacturing />} />
            <Route path="/kra-etims" element={<KraEtims />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
